import { render, staticRenderFns } from "./use_record.vue?vue&type=template&id=6878af6d"
import script from "./use_record.vue?vue&type=script&lang=js"
export * from "./use_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports